import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

const useSEOData = () => {
    const location = useLocation();
    const pathname = location.pathname;

    const productDetailData = useSelector((state) => state.product.productDetailData);
    const blogContentData = useSelector((state) => state.webSetting.blogContentData);
    const seoReferenceData = useSelector((state) => state.webSetting.seoMetaData); // Replace with your actual SEO data source

    const seoData = useMemo(() => {
        if (pathname.startsWith('/products/')) {
            return productDetailData;
        } else if (pathname.startsWith('/blog/')) {
            return blogContentData;
        } else {
            return seoReferenceData;
        }
    }, [pathname, productDetailData, blogContentData, seoReferenceData]);

    return seoData;
};

export default useSEOData;
